import { motion } from "framer-motion";

import { fadeUp, staggerContainer, viewportOnce } from "../../Utils/animations";
import { cx } from "../../Utils/helpers";

/**
 * Standard section header: eyebrow, title, description.
 * `highlight` gradient-tints the trailing phrase of the title.
 */
function SectionTitle({ eyebrow, title, highlight, description, align = "left", className, children }) {
  return (
    <motion.div
      className={cx("section-head", align === "center" && "section-head--center", className)}
      variants={staggerContainer(0.09)}
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
    >
      {eyebrow && (
        <motion.span className="section-eyebrow" variants={fadeUp()}>
          <span className="section-eyebrow__dot" aria-hidden="true" />
          {eyebrow}
        </motion.span>
      )}

      {title && (
        <motion.h2 className="section-title" variants={fadeUp(0.05)}>
          {title}
          {highlight && <> <span className="text-gradient">{highlight}</span></>}
        </motion.h2>
      )}

      {description && (
        <motion.p className="section-description" variants={fadeUp(0.1)}>
          {description}
        </motion.p>
      )}

      {children && <motion.div variants={fadeUp(0.15)}>{children}</motion.div>}
    </motion.div>
  );
}

export default SectionTitle;
